import React from "react";
import { Box, Typography } from "@mui/material";

interface RichTextDisplayProps {
	content: string | null | undefined;
	sx?: object;
}

const RichTextDisplay: React.FC<RichTextDisplayProps> = ({ content, sx = {} }) => {
	const hasHtmlContent =
		content && typeof content === "string" && /<[a-z][\s\S]*>/i.test(content);

	if (!content || (typeof content === "string" && content.trim() === "")) {
		return null;
	}

	return (
		<Box
			sx={{
				whiteSpace: "pre-wrap",
				wordBreak: "break-word",
				overflow: "auto",
				maxHeight: 1600,
				overflowY: "auto",
				resize: "vertical",
				"& .rich-text-content": { whiteSpace: "normal", wordBreak: "break-word" },
				"& table": { borderCollapse: "collapse", width: "max-content", minWidth: "100%", margin: "8px 0" },
				"& th, & td": { border: "1px solid #ddd", padding: "8px", textAlign: "left" },
				"& th": { backgroundColor: "#f5f5f5" },
				"& ul, & ol": { display: "block", margin: "8px 0", paddingLeft: "24px" },
				"& ul": { listStyleType: "disc" },
				"& ol": { listStyleType: "decimal" },
				"& li": { display: "list-item", margin: "4px 0" },
				"& a": { color: "#1976d2", textDecoration: "underline", cursor: "pointer" },
				...sx,
			}}
		>
			{hasHtmlContent ? (
				<div className="rich-text-content" dangerouslySetInnerHTML={{ __html: content }} />
			) : (
				<Typography component="pre" sx={{ whiteSpace: "pre-wrap", m: 0 }}>{content}</Typography>
			)}
		</Box>
	);
};

export default RichTextDisplay;